module.exports = "//static.hsappstatic.net/commerce-tools-ui-lib/static-1.5856/images/2023_ServiceHub_Help_Desk_Ticket1.svg"